import {
    Inter, Cairo, Tajawal, Amiri, Roboto, Open_Sans, Almarai, IBM_Plex_Sans_Arabic, Plus_Jakarta_Sans
} from 'next/font/google'

const interFont = Inter({ subsets: ['latin'], display: 'swap', variable: '--font-inter' });
const cairoFont = Cairo({ subsets: ['arabic', 'latin'], display: 'swap', variable: '--font-cairo' });
const tajawalFont = Tajawal({ subsets: ['arabic', 'latin'], weight: ['400', '500', '700'], display: 'swap', variable: '--font-tajawal' });
const amiriFont = Amiri({ subsets: ['arabic', 'latin'], weight: ['400', '700'], display: 'swap', variable: '--font-amiri' });
const robotoFont = Roboto({ subsets: ['latin'], weight: ['400', '500', '700'], display: 'swap', variable: '--font-roboto' });
const openSansFont = Open_Sans({ subsets: ['latin'], weight: ['400', '600', '700'], display: 'swap', variable: '--font-open-sans' });
const almaraiFont = Almarai({ subsets: ['arabic'], weight: ['300', '400', '700', '800'], display: 'swap', variable: '--font-almarai' });
const ibmArabicFont = IBM_Plex_Sans_Arabic({ subsets: ['arabic', 'latin'], weight: ['100', '200', '300', '400', '500', '600', '700'], display: 'swap', variable: '--font-ibm-arabic' });
const jakartaFont = Plus_Jakarta_Sans({ subsets: ['latin'], weight: ['300', '400', '500', '600', '700'], display: 'swap', variable: '--font-jakarta' });

export const fonts = {
    inter: interFont,
    cairo: cairoFont,
    tajawal: tajawalFont,
    amiri: amiriFont,
    roboto: robotoFont,
    "open sans": openSansFont,
    almarai: almaraiFont,
    "ibm plex sans arabic": ibmArabicFont,
    "plus jakarta sans": jakartaFont,
}

export type SupportedFont = keyof typeof fonts;

export const getFont = (family: string) => {
    const key = family.toLowerCase() as SupportedFont;
    return fonts[key] || fonts.inter;
}
